import {Store, createStore} from "vuex";
import ParkTrailsModule, {ParkTrailsState} from "./modules/ParkTrailsModule";

export interface RootState {
  parkTrails: ParkTrailsState
}

export const store: Store<RootState> = createStore({
  modules: {
    parkTrails: new ParkTrailsModule(),
  }
});

store.subscribe((mutation, state) => {
  if (
    mutation.type === 'parkTrails/setDistanceRangeMax' ||
    mutation.type === 'parkTrails/setElevations' ||
    mutation.type === 'parkTrails/setDifficulties' ||
    mutation.type === 'parkTrails/removeTrailTag' ||
    mutation.type === 'parkTrails/addTrailTag' ||
    mutation.type === 'parkTrails/setSelectedTrailTags'
  ) {
    store.dispatch('parkTrails/getGraphResponse')
  }
})
